import axios from 'axios';
import dayjs from 'dayjs';
import convert from 'xml-js';

const apiList = [
  'https://blog.apnic.net/tag/security/feed/',
  'https://blog.apnic.net/tag/RPKI/feed/'
];

const state = {
  rssData: []
};

const getters = {
  rssData: state => {
    return state.rssData;
  }
};

const mutations = {
  setRSSData: (state, rssData) => {
    state.rssData = rssData;
  }
};

const actions = {
  fetchRSS: context => {
    axios
      .all(apiList.map(i => axios.get(i)))
      .then(resArray => {
        let articles = [];
        resArray.forEach(i => articles.push(...parseRSSData(i)));
        // remove duplicate
        articles = removeDuplicateArticles(articles);
        articles.sort(compare);
        context.commit('setRSSData', articles);
      })
      .catch(e => console.error(e));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

function parseRSSData(res) {
  const json = convert.xml2js(res.data, { compact: false });
  let articles = json.elements[0].elements[0].elements.filter(
    i => i.name === 'item'
  );
  articles = articles.map(i => {
    const article = {};
    i.elements.forEach(j => {
      const value = j.elements[0][j.elements[0].type];
      if (j.name === 'title') {
        article.title = value;
      }
      if (j.name === 'link') {
        article.link = value;
      }
      if (j.name === 'pubDate') {
        article.date = dayjs(value).format('YYYY-MM-DD');
      }
      if (j.name === 'dc:creator') {
        article.author = value;
      }
      if (j.name === 'description') {
        article.description = value;
      }
    });
    return article;
  });
  return articles;
}

function compare(a, b) {
  if (dayjs(a.date).isAfter(dayjs(b.date))) {
    return -1;
  }
  if (dayjs(a.date).isBefore(dayjs(b.date))) {
    return 1;
  }

  return 0;
}

function removeDuplicateArticles(articles) {
  const set = new Set();
  return articles.filter(i => {
    if (!set.has(i.link)) {
      set.add(i.link);
      return true;
    }
    return false;
  });
}
